// extracted by mini-css-extract-plugin
module.exports = {"footerlinksContainer":"footerlinks-module--footerlinksContainer","lh":"footerlinks-module--lh","siteLogo":"footerlinks-module--siteLogo","br":"footerlinks-module--br"};